import usePage from '../../hooks/usePage';
import { getComponentFromName } from '../../lib/utils';

import { useTheme } from '../../contexts/ThemeContext';
import DefaultComponent from './HomeDefault';
import * as Components from './homes';

function HomePage(props) {
    const { name, variant = null } = useTheme();
    const { page } = usePage();
    const { type = null } = page || {};
    // console.log('home page', page);

    const Component =
        (type === 'mvp' || type === 'coorslive_landing'
            ? getComponentFromName(Components, type, null)
            : null) ||
        getComponentFromName(Components, name, null) ||
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(Components, v, null),
            null,
        ) ||
        DefaultComponent;

    return Component !== null ? <Component {...props} page={page} /> : null;
}

export default HomePage;
